export const SITE_META_DATA: Record<string, string> = {
  DEFAULT_TITLE: 'DoorDash - Food and Drinks.',
  DEFAULT_DESCRIPTION: 'DoorDash. Contactless Order & Payment Platform.',
  DEFAULT_IMAGE: 'https://static.bbot.menu/img/bbot_OG.png',
};
